import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
// No click listeners on this page — selection drives the output — so we don't
// need an `apiReady` handle here; just kick off initialization.
waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI?.registerOnSelection((selectedItem) => {
      if (selectedItem != null) {
        var mid = selectedItem.item.modelId;
        var iid = selectedItem.item.modelItemId;
        LwAPI?.getProperties(mid + ":" + iid)
          .then((props) => {
            var list = "";
            for (let i = 0; i < props.data.length; i++) {
              list +=
                props.data[i]["name"] +
                "\n" +
                props.data[i]["value"] +
                "\n-------------\n";
            }
            const outputElement = document.getElementById(
              "output"
            ) as HTMLTextAreaElement;
            if (outputElement) {
              outputElement.value = list;
            }
          })
          .catch(function (err) {
            alert(
              "Error from getProperties:\n" + JSON.stringify(err, null, " ")
            );
          });
      } else {
        const outputElement = document.getElementById(
          "output"
        ) as HTMLTextAreaElement;
        if (outputElement) {
          outputElement.value = "Nothing selected";
        }
      }
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });
